/**
 * Orders Container Component
 *
 * Main component for orders management
 * Routes between:
 * - OrdersList: Shows all user orders (/account/orders)
 * - OrderDetail: Shows general order info (/account/orders/:orderId)
 * - OrderLicensesDetail: Shows licenses/invitations (/account/orders/:orderId/licenses)
 */

import React from 'react';

import OrdersList from './OrdersList';
import OrderDetail from './OrderDetail';
import OrderLicensesDetail from './OrderLicensesDetail';

interface OrdersAccountPageProps {
  orderId?: string; // Optional ID from URL params - if present, show detail view
  subpage?: string; // Optional subpage from URL params (e.g., 'licenses')
}

const OrdersAccountPage: React.FC<OrdersAccountPageProps> = ({ orderId, subpage }) => {
  // Show licenses detail page if orderId and subpage='licenses' is provided
  if (orderId && subpage === 'licenses') {
    return <OrderLicensesDetail orderId={orderId} />;
  }

  // Show general order detail page if only orderId is provided
  if (orderId) {
    return <OrderDetail orderId={orderId} />;
  }

  // Default: show orders list
  return <OrdersList />;
};

export default OrdersAccountPage;
